import { categories } from '@/mocks/kanliao';

const flagStyle: Record<string, string> = {
  热: 'bg-rose-100 text-rose-600',
  新: 'bg-emerald-100 text-emerald-600',
  稳: 'bg-amber-100 text-amber-600',
};

export default function CategoryBoard() {
  return (
    <section id="board" className="bg-gradient-to-b from-white/50 to-amber-50/60 py-12">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold tracking-wide text-orange-500">CHANNEL BOARD</span>
          <h2 className="mt-1 text-2xl font-black tracking-tight text-stone-900 md:text-3xl">
            分区直达 · 想看的内容都归了类
          </h2>
          <p className="mt-2 text-sm text-stone-500">
            分类清晰，照着方向点进去就能看料，无需一条条翻找收藏夹。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {categories.map((cat) => (
            <article
              key={cat.title}
              className="rounded-2xl border border-stone-200/80 bg-white/90 p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-100 text-orange-600">
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="text-base font-bold text-stone-800">{cat.title}</h3>
                  <p className="text-xs text-stone-400">{cat.lead}</p>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {cat.items.map((it) => (
                  <a
                    key={it.name}
                    href="#board"
                    className="group flex items-start justify-between gap-2 rounded-lg border border-transparent bg-amber-50/60 px-3 py-2.5 transition-colors hover:border-amber-200 hover:bg-amber-50"
                  >
                    <span className="flex flex-col">
                      <span className="flex items-center gap-1.5 text-sm font-semibold text-stone-700 group-hover:text-orange-600">
                        {it.name}
                        {it.flag && (
                          <em
                            className={`not-italic rounded px-1.5 py-px text-[10px] font-semibold ${flagStyle[it.flag]}`}
                          >
                            {it.flag}
                          </em>
                        )}
                      </span>
                      <span className="mt-0.5 text-xs text-stone-400">{it.desc}</span>
                    </span>
                    <i className="ri-arrow-right-up-line mt-0.5 shrink-0 text-sm text-stone-300 transition-colors group-hover:text-orange-500" />
                  </a>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}